/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import FormatAlignLeftIcon from '@material-ui/icons/FormatAlignLeft';
import FormatAlignCenterIcon from '@material-ui/icons/FormatAlignCenter';
import FormatColorTextIcon from '@material-ui/icons/FormatColorText';
import SortByAlphaIcon from '@material-ui/icons/SortByAlpha';

export const DefaultTools = [

    {
        value: 'left',
        type: 'textAlign',
        label: 'Left',
        icon: <FormatAlignLeftIcon style={{ fill: '#7737A9' }} />,
        title: 'Align Left',
        list: [],
    },
    {
        value: 'center',
        type: 'textAlign',
        label: 'Center',
        icon: <FormatAlignCenterIcon style={{ fill: '#7737A9' }} />,
        title: 'Align Center',
        list: [],
    },
    {
        value: 'font',
        type: 'fontFamily',
        label: 'Font',
        icon: <SortByAlphaIcon />,
        title: 'Select Font',
        list: [
            {
                label: 'Dancing',
                value: 'Dancing, Verdana, Arial, sans-serif',
            },
            {
                label: 'Roboto',
                value: 'Roboto, Helvetica, Arial, sans-serif',
            },
            {
                label: 'Caslon',
                value: 'Caslon, Garamond, Times, serif',
            },
            {
                label: 'Crimson',
                value: 'Crimson, Garamond, Times, serif',
            },
            {
                label: 'LatoRegular',
                value: 'LatoRegular, Arial, Verdana, sans-serif',
            },
        ],
    },
    {
        value: 'color',
        type: 'color',
        label: 'Color',
        icon: <FormatColorTextIcon />,
        title: 'Select Color',
        list: [
            {
                label: 'White',
                value: '#ffffff',
            },
            {
                label: 'Red',
                value: '#ff0000',
            },
            {
                label: 'Black',
                value: '#000000',
            },
            {
                label: 'Purple',
                value: '#8020BB',
            },
            {
                label: 'Green',
                value: '#50AD16',
            },
            {
                label: 'Blue',
                value: '#5B7FFE',
            },
            {
                label: 'Orange',
                value: '#FE825B',
            },
        ],
    },

];

export default {};
